export default function getFileNameFromUrl(url) {
  return url
    .split("#")
    .shift()
    .split("?")
    .shift()
    .split("/")
    .pop();
}

export function getFileNameFromUrlV2(url) {
  if (!url) return "";

  try {
    const pathname = new URL(url).pathname;
    return pathname.substring(pathname.lastIndexOf("/") + 1);
  } catch {
    return getFileNameFromUrl(url);
  }
}
